import Grid from '@material-ui/core/Grid';

import Input from '~/ui/components/inputs/Input';
import InputMask from '~/ui/components/inputs/InputMask';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import type { PersonalDetailsRightColumnProps } from '../types';

const PersonalDetailsRightColumn = ({
  options,
  control,
  register,
  errors,
  showPrimaryRoleTeams,
  isGlobalUserSelected,
  filteredMemberOptions,
  teamOptions,
  setAll,
  isTeamOptionDisabledForPa,
  normalizeTeamIdsMultiValue,
  restrictGuTeamsForPa,
  isProgramAssistant,
}: PersonalDetailsRightColumnProps) => (
  <Grid item sm={6}>
    <Grid container spacing={2} sm={12}>
      {showPrimaryRoleTeams && (
        <>
          <Grid item sm={isGlobalUserSelected ? 6 : 12}>
            <Select
              options={filteredMemberOptions}
              name="primaryRole"
              control={control}
              errors={errors}
              label="Primary Role"
              hideSelectedOptions={false}
              isDisabled={isGlobalUserSelected && isProgramAssistant}
              openMenuOnFocus
            />
          </Grid>
          {isGlobalUserSelected && (
            <Grid item sm={6}>
              <Select
                isMulti
                oneLineMulti
                closeMenuOnSelect={false}
                showCustomComponents
                showSelectAll
                hideSelectedOptions={false}
                name="teamIds"
                options={teamOptions}
                control={control}
                errors={errors}
                label="Assigned Teams"
                isClearable
                placeholder="All"
                setAll={setAll}
                isOptionDisabled={restrictGuTeamsForPa ? isTeamOptionDisabledForPa : undefined}
                normalizeMultiValue={normalizeTeamIdsMultiValue}
              />
            </Grid>
          )}
        </>
      )}
      <Grid item sm={12}>
        <Select
          isMulti
          control={control}
          errors={errors}
          name="subRoleIds"
          label="Sub-Roles"
          options={options.subRoles}
          hideSelectedOptions={false}
          openMenuOnFocus
        />
      </Grid>
      <Grid item sm={12}>
        <Input register={register} errors={errors} name="address.city" label="City" />
      </Grid>
      <Grid item sm={12}>
        <Input register={register} errors={errors} name="address.line1" label="Address 1" />
      </Grid>
      <Grid item sm={12}>
        <Input register={register} errors={errors} name="address.line2" label="Address 2" />
      </Grid>
      <Grid item sm={6}>
        <Select
          options={options.states}
          name="address.stateId"
          control={control}
          errors={errors}
          label="State"
          hideSelectedOptions={false}
          openMenuOnFocus
        />
      </Grid>
      <Grid item sm={6}>
        <InputMask
          alwaysShowMask={false}
          mask="99999"
          name="address.zipCode"
          control={control}
          errors={errors}
          label="Zip Code"
        />
      </Grid>
    </Grid>
  </Grid>
);

export default PersonalDetailsRightColumn;
